import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { getMinePosts } from "../../../../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import { useRouteBaseStateContext } from "../../../../../../Context/RouteBaseStateContext";
import { formatNumberWithCommas } from "../../../../../Common/AllDateTimeReleventFormate";
import GetPrice from "../PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import GetPricewitoutlabel from "../PostedProjects/MineActiveProject/ProjectModels/GetPricewitoutlabel";

export default function PostedJobs() {
  const { urlstate, setMyorderRecentjobsroute, setMyorderActivejobsroute, setMyAllJobListroute } =
    useRouteBaseStateContext();
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  const postlistmine = useSelector(
    ({ posts: { postlistmine } }) => postlistmine,
  );

  useEffect(() => {
    dispatch(getMinePosts(3));
  }, [dispatch]);

  const recentPosts = postlistmine?.filter((item) => item.status == 21) || [];
  const activePosts = postlistmine?.filter((item) => item.status == 22) || [];

  return (
    <div className="posted-project">
      <div className="d-flex justify-content-between align-items-center">

        <h4>Posted Part time Job (PTJ) ({recentPosts.length})</h4>
        <button className='buttons background-button' onClick={() => {
          navigate(`/${lan}/dashboard/myorders/job/listings`)
          setMyAllJobListroute('paymentpendingjobs')
        }}>
          View More
        </button>
      </div>
      {recentPosts.length > 0 ? (
        <div className="recent-post row recent-job">
          {recentPosts.slice(0, 4).map((item, index) => (
            <div className="col-md-6" key={index}
              onClick={() => {
                navigate(`/${lan}/dashboard/myorders/job/recent/${item.id}`);
                setMyorderRecentjobsroute("");
              }}>
              <div className="post-back recent-back recent-first">
                <div className="recent-detail">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/myorders/jobtype.svg`}
                      alt=""
                    />
                    Job type:
                    {item?.work_location == 1
                      ? "Virtual"
                      : item?.work_location == 2
                        ? "Physical"
                        : ""}
                  </p>
                  <h3>{item?.title}</h3>
                  <h1>
                    <GetPricewitoutlabel
                      type={item?.type}
                      price={item?.price}
                      price2={item?.price2}
                      hiring_type={item?.hiring_type}
                    />
                  </h1>
                </div>
                <div className="recent-detail">
                  <p>Proposals</p>
                  <h3>{item?.proposal_count} Applicants</h3>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/${lan}/dashboard/myorders/job/recent/${item.id}`,
                    );
                    setMyorderRecentjobsroute("");
                  }}
                  className="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <PostNotFound title={"No Post Found"} />
      )}
      <div className="d-flex justify-content-between align-items-center">
        <h4>Active Part time Job (PTJ) ({activePosts.length})</h4>
        <button className='buttons background-button' onClick={() => {
          navigate(`/${lan}/dashboard/myorders/job/listings`);
          setMyAllJobListroute('activejobs')
        }}>
          View More
        </button>
      </div>
      {activePosts.length > 0 ? (
        <div className="recent-post row recent-job">
          {activePosts.slice(0, 4).map((item, index) => (
            <div className="col-md-6" key={item.id}
              onClick={() => {
                navigate(`/${lan}/dashboard/myorders/job/active/${item.id}`);
                setMyorderActivejobsroute("");
              }}
            >
              <div className="post-back recent-back">
                <div className="recent-detail">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/myorders/jobtype.svg`}
                      alt=""
                    />
                    Job type:
                    {item?.work_location == 1
                      ? "Virtual"
                      : item?.work_location == 2
                        ? "Physical"
                        : ""}
                  </p>
                  <h3>{item?.title}</h3>
                  <h1>
                    <h1>
                      $
                      {item?.hiring_type == 1
                        ? `${formatNumberWithCommas(item?.proposed_price)}/hr`
                        : ""}
                      {item?.hiring_type == 3
                        ? `${formatNumberWithCommas(item?.proposed_price)}/weekly`
                        : ""}
                      {item?.hiring_type == 4
                        ? `${formatNumberWithCommas(item?.proposed_price)}/month`
                        : ""}
                    </h1>
                  </h1>
                </div>
                <div className="recent-detail">
                  <p>Logged hour</p>
                  <h3>{item?.logged_hours || 0} hrs</h3>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/${lan}/dashboard/myorders/job/active/${item.id}`,
                    );
                    setMyorderActivejobsroute("");
                  }}
                  className="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <PostNotFound title={"No Post Found"} />
      )}
    </div>
  );
}
